<authority-labs-menu
  icon="menu"
  *ngIf="folderId"
  [title]="translationPath + 'title' | transloco"
  [menuActions]="menuActions"
  (actionClick)="menuClick($event)"
></authority-labs-menu>
